import { useQuery, UseQueryOptions } from 'react-query';

import {Guid, SignedNda } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useSignedNdaQuery (
	guid: Guid | undefined,
	options?: Omit<UseQueryOptions<SignedNda, unknown, SignedNda, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.LenderNda.Signed(guid),
		() =>
			AxiosUtils.getResponseData<SignedNda>(
				api.get(CerebroApiEndpoints.LenderNda.Signed(guid))
			),
		options
	);
}
